import React from 'react';
import { connect } from 'react-redux';

import styles from './offerPaidHits.scss';

const OfferPaidHits = ({ auth }) => {
    return (
        <div className={`${styles.offerPaidHits} bg-white`}>
            <div className="container-fluid bg-black">
                <div className="container pb32">
                    <div className="row">
                        <div className="col-12 col-lg-3 offset-lg-3 pt24 text-center">
                            <img
                                src="img/v2/graphics/img-s-players.png"
                                srcSet="img/v2/graphics/img-s-players@2x.png 2x,
                                img/v2/graphics/img-s-players@3x.png 3x"
                                className="img_s_players"
                            />
                        </div>
                        <div className="col-12 col-lg-3 pt24">
                            <div className="text-wrapper">
                                <div className="text-script">Paid Hits</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container pb64">
                <div className="row">
                    <div className="col-12 col-md-6 offset-md-3">
                        <h5>Get paid to play the game you love!</h5>
                        <ul className="checkmark">
                            <li>Create paid hitting sessions which become available to players in the UTR Sports community</li>
                            <li>Find and play with more experienced players or coaches</li>
                            <li>Generate revenue while sharing your experience</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6 offset-md-3">
                        <h5>Eligibility Criteria</h5>
                        <ul className="caret">
                            <li>Be at least 16 years of age</li>
                            <li>Have a 8+ UTR Rating or have played/coached on the Pro Tour, in College, or a nationally ranked Junior</li>
                            <li>Be a UTR Sports power subscriber</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6 offset-md-3 text-center">
                        <a
                            className="btn btn-primary btn-xl text-uppercase mt72"
                            href={`https://utr.typeform.com/to/v8DoryTr#mid=${auth.user?.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Become a paid hitter
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

OfferPaidHits.propTypes = {

};

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(OfferPaidHits);
